module.exports = __webpack_public_path__ + "img/bank-line.9d32c4d3.svg";